import { render, staticRenderFns } from "./ExamScore.vue?vue&type=template&id=e3137d26&"
import script from "./ExamScore.vue?vue&type=script&lang=js&"
export * from "./ExamScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports